import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LeaseTypeSelectorComponent } from '../Selectors/Lease-Type-Selector/leaseTypeSelector.component';

export interface EntityImportEditorLeaseTypeSelectorCellEditorParams extends ICellEditorParams {
    getLeaseTypes(row: Compliance.ImportGridRowGridModel): Compliance.LeaseTypeModel[];
}

@Component({
    selector: 'entity-import-editor-lease-type-selector',
    template: `
        <lease-type-selector #leaseTypeSelector
                                  [formControl]="leaseType"
                                  (changed)="onChanged($event)"
                                  [values]="values"></lease-type-selector>`,
    standalone: false
})
export class EntityImportEditorLeaseTypeSelectorCellEditorComponent implements ICellEditorAngularComp {
    gridRow: Compliance.ImportGridRowGridModel;

    focusIn(): void {
    }

    focusOut(): void {
    }

    getValue(): any {
        return this.leaseType.value;
    }

    isCancelAfterEnd(): boolean {
        if (this.leaseTypeSelector.value === '') {
            this._params.node.setDataValue(this._params.column.getColId(), null);
            return true;
        }
        return false;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return false;
    }

    leaseType: UntypedFormControl = new UntypedFormControl();
    values: Compliance.LeaseTypeModel[];

    @ViewChild('leaseTypeSelector', { static: true }) leaseTypeSelector: LeaseTypeSelectorComponent;

    private _params: EntityImportEditorLeaseTypeSelectorCellEditorParams;

    async agInit(params: EntityImportEditorLeaseTypeSelectorCellEditorParams): Promise<void> {
        this.gridRow = params.data as Compliance.ImportGridRowGridModel;

        this._params = params;
        this.leaseType.setValue(params.value);
        this.values = await params.getLeaseTypes(this.gridRow);
    }

    onChanged(value: string) {
        if (!value) {
            this.leaseType.setValue(value);
            return;
        }
        if (this.leaseType.value !== value) {
            this.leaseType.setValue(value);
            this._params.node.setDataValue(this._params.column.getColId(), value);
        }
    }
}
